import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["preview", "input", "initial"];

  previewImage(event) {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Please upload a valid image file (JPG, PNG, GIF, WebP).");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.previewTarget.src = reader.result;
      this.previewTarget.classList.remove("hidden");
      this.initialTarget?.classList.add("hidden");
    };
    reader.readAsDataURL(file);
  }
}
